module.exports = __webpack_public_path__ + "img/menu_icon.8684d03d.svg";